import { playerState } from '../../../player-state';

export type PlayerAnimState = 'Standing';

export const PLAYER_LAYER_NAMES = [
  'weapon_back',
  'right_arm',
  'right_arm_armor',
  'legs',
  'leg_armor',
  'torso',
  'strap',
  'torso_armor',
  'left_arm',
  'left_arm_armor',
  'head',
  'head_armor',
] as const;

export type PlayerLayerName = (typeof PLAYER_LAYER_NAMES)[number];

export type PlayerLoadSpec = {
  name: PlayerLayerName;
  json: string;
  img: string;
};

const STANDING_BODY = 'Character/Traits/Body Tan/Standing';

function addLayer(
  specs: PlayerLoadSpec[],
  name: PlayerLayerName,
  basePath: string,
) {
  specs.push({
    name,
    json: `${basePath}.grid.json`,
    img: `${basePath}-sheet.grid.png`,
  });
}

/** Default tan booga + starter clothing. Standing only for mobile boot. */
export function collectPlayerLoadSpecs(state: PlayerAnimState = 'Standing'): PlayerLoadSpec[] {
  if (state !== 'Standing') return [];

  const specs: PlayerLoadSpec[] = [];
  addLayer(specs, 'right_arm', `${STANDING_BODY}/RightArmTan-Standing`);
  addLayer(specs, 'legs', `${STANDING_BODY}/LegsTan-Standing`);
  addLayer(specs, 'torso', `${STANDING_BODY}/TorsoTan-Standing`);
  addLayer(specs, 'strap', 'Character/Strap/StrapStanding');
  addLayer(specs, 'left_arm', `${STANDING_BODY}/LeftArmTan-Standing`);
  addLayer(specs, 'head', `${STANDING_BODY}/HeadTan-Standing`);

  if (playerState.equipped.body === 'Pink Hunter Fur') {
    const p = 'Character/Traits/Clothing/Pink Hunter Fur';
    addLayer(specs, 'torso_armor', `${p}/PinkHunterFur-Standing`);
    addLayer(specs, 'left_arm_armor', `${p}/PinkHunterFurSleeveL-Standing`);
    addLayer(specs, 'right_arm_armor', `${p}/PinkHunterFurSleeveR-Standing`);
  } else {
    addLayer(specs, 'leg_armor', `${STANDING_BODY}/HipsterPantsPurple-Standing`);
    addLayer(specs, 'head_armor', `${STANDING_BODY}/CasualHairband-Standing`);
  }

  const weapon = playerState.equipped.weapon;
  if (weapon === 'WoodClub') {
    addLayer(specs, 'weapon_back', 'Character/Traits/Weapon/WoodenClub/WoodenClub-Standing');
  } else if (weapon === 'Boogatooth Lure') {
    addLayer(specs, 'weapon_back', 'Character/Traits/Weapon/BoogatoothLure/Lure-Standing');
  }

  return specs;
}

export function playerTextureKey(state: PlayerAnimState, layerName: string) {
  return `player-${state.toLowerCase()}-${layerName}`;
}

export function playerAnimKey(state: PlayerAnimState, layerName: string) {
  return `${playerTextureKey(state, layerName)}-anim`;
}

export function hasBackWeaponSprite(weapon: string | null) {
  return weapon === 'WoodClub' || weapon === 'Boogatooth Lure';
}
